import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LngDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

i18n
  .use(initReactI18next)
  .use(LngDetector)
  .use(
    resourcesToBackend((language, namespace, callback) => {
      import(`./locales/${language}/${namespace}.json`)
        .then((resources) => {
          callback(null, resources.default ?? resources);
        })
        .catch((error) => {
          callback(error, null);
        });
    }),
  )
  .init({
    supportedLngs: ['pt-BR', 'en'],
    fallbackLng: 'pt-BR',
    detection: {
      // Order of detection methods - localStorage first, then fallback
      order: ['localStorage'],
      // Cache language selection in localStorage
      caches: ['localStorage'],
      // Key to store the language in localStorage
      lookupLocalStorage: 'i18nextLng',
    },
    ns: [
      'status',
      'errors',
      'error-codes',
      'carriers',
      'order-view-customer',
      'order-view-delivery',
      'order-view-destination-address',
      'order-view-info',
      'order-view-item',
      'order-view-volume',
      'order-view-titles',
      'cognito-error',
      'permissions',
      'order-types',
      'order-providers',
      'csv-trace',
      'csv-errors',
      'csv-importer',
      'create-delivery-sidepanel',
      'yup',
      'pickup-pin',
    ],
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
